const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="currentColor" d="M15.583.187a1 1 0 0 0-1.396.23L4.831 13.472l-3.124-3.128a1 1 0 1 0-1.414 1.415l3.956 3.958a1.016 1.016 0 0 0 1.52-.124L15.813 1.584a1 1 0 0 0-.23-1.397"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
